import React from 'react';
import { ColumnChart } from '../../../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart';
import { formatPercentage } from '../../../../../CommonUtils/formatNumber';
import { useIsEmbeddedMobile } from '../../../../../_hooks/useIsEmbeddedMobile';
import { CHART_HEIGHT } from '../../PerformanceChart.meta';

interface Props {
  data: {
    series: {
      data: {
        color: string;
        name: string;
        y: number;
      }[];
    }[];
    categories: string[];
  };
}

export const PerformanceChartContent = ({ data }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <ColumnChart
      series={data.series}
      categories={data.categories}
      yAxisType="percentage"
      customSettings={{
        legend: {
          enabled: false,
        },

        chart: {
          height: isEmbeddedMobile ? CHART_HEIGHT : 280,
        },

        tooltip: {
          shared: true,

          formatter() {
            let tooltip = `
                <span style="font-size: 10px">
                ${(this as any).x}
                </span><table>
            `;

            if ((this as any).points) {
              (this as any).points.forEach(({ y, color }) => {
                tooltip += `
                    <tr>
                    <td>
                        <span style="color:${color}">\u25CF</span>
                    </td>
                    <td>
                        <span style="font-weight: 600">
                        ${formatPercentage(Number(y), { decimalPlaces: 2 })}
                        </span>
                    </td>
                    </tr>
                `;
              });
            }

            return `${tooltip}</table>`;
          },
        },
      }}
    />
  );
};
